export default "__VITE_ASSET__58954c86__"